import Styles from "./Card.module.css";
import React, { useState } from "react";
import { useSpring, animated } from "react-spring";

function Card({ imagen, title, textCard, link }) {
  const [show, setShown] = useState(false);

  const props3 = useSpring({
    transform: show ? "scale(1.03)" : "scale(1)",
    boxShadow: show
      ? "0 20px 25px rgb(0 0 0 / 25%)"
      : "0 2px 10px rgb(0 0 0 / 8%)"
  });
  return (
    <animated.div
      className={Styles.card}
      style={props3}
      onMouseEnter={() => setShown(true)}
      onMouseLeave={() => setShown(false)}
    >
      <a href={imagen}>
        <img src={imagen} alt="" />
      </a>
      <h2>{title}</h2>
      <p>
        {textCard}
      </p>
      <div className={Styles.btnn}>
        <a href={link}>Click to learn more.</a>
      </div>
    </animated.div>
  );
}

export default Card;
